module.exports = __webpack_public_path__ + "static/media/doctor.1b5237f3.svg";